@if (view$ | async; as view) {
    <div>
        <div [class]="view.isSuccess ? 'mobi-ui-wrapper-footer-success' : 'mobi-ui-wrapper-footer'">
            @if (view.contact && !view.protekta) {
                <app-contact [contact]="view.contact"></app-contact>
            }
            @if (view.protekta && view.isSuccess) {
                <app-contact-protekta></app-contact-protekta>
            }
            @if (!view.contact && view.mobiFallback) {
                <app-concierge [fallback]="view.mobiFallback"></app-concierge>
            }
            @if (view.protekta && !view.isSuccess) {
                <app-concierge-protekta></app-concierge-protekta>
            }
            <mobi-ui-footer-major (languageChange)="changeLanguage($event)">
                @if (view.protekta) {
                    <a
                        href="{{
                            'footer.datenschutzerklaerung.protekta.mobiliar.link' | translate
                        }}"
                        >{{ 'footer.datenschutzerklaerung' | translate }}
                    </a>
                }
                @if (!view.protekta) {
                    <a href="{{ 'footer.datenschutzerklaerung.mobi.link' | translate }}">{{
                        'footer.datenschutzerklaerung' | translate
                    }}</a>
                }
            </mobi-ui-footer-major>
        </div>
    </div>
}
